import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import { Link } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { Typography } from "@material-ui/core";
import { resetPassword } from "../features/users/auth";
import { setXClientHost } from "../common/utils.js";

const ColorButton = withStyles((theme) => ({
  root: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: "#D86D7E",
    color: "#FFF",
    "&:hover": {
      opacity: 0.9,
      backgroundColor: "#D86D7E",
    },
    // fontWeight: 'bold',
  },
}))(Button);

const SecondaryButton = withStyles((theme) => ({
  root: {
    // margin: theme.spacing(3, 0, 2),
    backgroundColor: "#ed5e9d",
    color: "#FFF",
    "&:hover": {
      backgroundColor: " #ce5087",
    },
    // fontWeight: 'bold',
  },
}))(Button);

const useStyles = makeStyles((theme) => ({
  // #42494E; light blue
  // #131f47; dark blue
  // #ed5e9d; pink
  paper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  linkText: {
    fontSize: 16,
    display: "flex",
    alignItems: "center",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: "#42494E",
    color: "#FFF",
  },
}));

export default function ResetPassword() {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  // const resetSuccess = useSelector((state) => state.signin.reset);
  // const error = useSelector((state) => state.signin.error);
  const error = false; // ~!!! temp
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmError, setConfirmError] = useState("");

  const submitReset = (event) => {
    event.preventDefault();
    const credentials = {
      username: username,
      password: password,
      resetToken: window.location.search.split("=")[1],
    };

    if (!validatePassword()) {
      setPasswordError("Invalid password");
    } else if (password !== confirmPassword) {
      setConfirmError("Passwords don't match");
    } else {
      setPasswordError("");
      setConfirmError("");
      dispatch(
        resetPassword({
          host: setXClientHost(),
          credentials: credentials,
        })
      );
    }
  };

  const validatePassword = () => {
    var conditions = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,15}$/;
    if (password.match(conditions)) {
      return true;
    } else {
      return false;
    }
  };

  // if (resetSuccess !== null) {
  //   history.push('/signin');
  // }

  return (
    <Card elevation={4}>
      <Container className={classes.paper} maxWidth="sm">
        <CssBaseline />
        <div>
          <img src="/ps-logo-new.png" style={{ width: "20rem" }} alt="logo" />{" "}
        </div>
        <Grid>
          <Typography>
            New password must be longer than 8 characters and contain at least
            one number and one special character
          </Typography>
        </Grid>
        <form className={classes.form} onSubmit={submitReset}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="username"
            label="Username"
            name="username"
            autoComplete="username"
            autoFocus
            onChange={(e) => setUsername(e.target.value)}
            error={error}
            helperText={error ? error.message : ""}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="new-password"
            label="New Password"
            type="password"
            id="new-password"
            autoComplete="new-password"
            onChange={(e) => setPassword(e.target.value)}
            inputProps={{ minLength: 8, maxLength: 99 }}
            error={passwordError}
            helperText={passwordError ? passwordError : ""}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="confirm-password"
            label="Confirm Password"
            type="password"
            id="confirm-password"
            autoComplete="new-password"
            onChange={(e) => setConfirmPassword(e.target.value)}
            inputProps={{ minLength: 8, maxLength: 99 }}
            error={confirmError}
            helperText={confirmError ? confirmError : ""}
          />
          <ColorButton type="submit" fullWidth variant="contained">
            Reset Password
          </ColorButton>
          <Link to="/">
            <SecondaryButton type="link" fullWidth variant="contained">
              Return to login
            </SecondaryButton>
          </Link>
        </form>
      </Container>
    </Card>
  );
}
